export { default as StatusIcon } from './status-icon'



// WEBPACK FOOTER //
// ./src/components/molecules/status-icon/index.ts